import React, { ReactNode } from 'react'
import classNames from 'classnames'
import ReactMarkdown from 'react-markdown'
import ContentfulQuery from '#src/containers/Contentful'
import { Link } from 'react-router-dom'
import { Button, CircleLoader, FullBlockLoader } from '@deal/components'
import { ContentfulFAQEntry } from '#src/typings/contentful'
import styles from './styles.css'

interface Props {
  Header?: ReactNode
  className?: string
  trimLength?: number
  faqSlug?: string | null
}

interface State {
  activeIndex?: number
}

class FAQ extends React.Component<Props, State> {
  DEFAULT_FAQ_SLUG = 'deal-faq-v1'

  constructor(props: Props) {
    super(props)

    this.state = {}

    this.toggleQuestion = this.toggleQuestion.bind(this)
  }

  public toggleQuestion(index: number) {
    let toSet: number | undefined = index
    if (index === this.state.activeIndex) {
      toSet = undefined
    }

    this.setState({
      activeIndex: toSet
    })
  }

  public render() {
    const { Header, className, trimLength, faqSlug } = this.props
    let queriedSlug = faqSlug

    if (!queriedSlug) {
      queriedSlug = this.DEFAULT_FAQ_SLUG
    }

    return (
      <ContentfulQuery template="faq" variation={queriedSlug}>
        {({ content, loading }) => {
          if (content && content.questions && content.questions.length > 0) {
            const questionList = trimLength
              ? content.questions.slice(0, trimLength)
              : content.questions

            return (
              <>
                {Header}
                <div className={classNames(styles.container, className)}>
                  {questionList.map((entry: ContentfulFAQEntry, idx: number) => (
                    <div className={styles.entry} key={idx}>
                      <button className={styles.question} onClick={() => this.toggleQuestion(idx)}>
                        <span className={styles.toggle}>
                          {idx === this.state.activeIndex ? '-' : '+'}
                        </span>{' '}
                        <span className={styles.question}>{entry.question}</span>
                      </button>
                      <div
                        className={classNames(styles.answer, {
                          [styles.expanded]: this.state.activeIndex === idx
                        })}
                      >
                        <ReactMarkdown source={entry.answer} />
                      </div>
                    </div>
                  ))}
                </div>
                <div className={styles.viewAll}>
                  <Link to="/faq">
                    <Button variant="secondary" size="large">
                      Read All FAQs
                    </Button>
                  </Link>
                </div>
              </>
            )
          } else if (loading) {
            return <FullBlockLoader loader={CircleLoader} />
          } else {
            return null
          }
        }}
      </ContentfulQuery>
    )
  }
}

export default FAQ
